<template>
	<nk-wrapper v-if="context.rubriken" spacing="md">
		<section
			v-for="(rubrik, rubrikIndex) in context.rubriken"
			id="results"
			:key="`${rubrikIndex}-rubrik-${rubrik.id}`"
		>
			<nk-list variant="overview">
				<nk-list-item
					v-for="(
						brancheneintrag, brancheneintragIndex
					) in rubrik.brancheneintraege"
					:key="`${brancheneintragIndex}-brancheneintrag-${brancheneintrag.id}`"
				>
					<article>
						<nk-row gutter="3" vertical-gutter="2">
							<nk-col cols="full" order="2" sm="auto" order-sm="1">
								<nk-list v-if="context.rubriken.length > 1" variant="clean">
									<nk-list-item icon="library">
										{{ rubrik.rubrik }}
									</nk-list-item>
								</nk-list>

								<nk-link :link="brancheneintrag.detailURL" block>
									<nk-title max-lines="2" size="lg" tag="h1">
										{{ brancheneintrag.titel }}
									</nk-title>
								</nk-link>

								<nk-address
									variant="vertical"
									:telefon="brancheneintrag.kontakt.telefon"
									:email="brancheneintrag.kontakt.email"
									:link="brancheneintrag.kontakt.link"
									:plz="
										brancheneintrag.zeige_adresse && brancheneintrag.adresse.plz
											? brancheneintrag.adresse.plz
											: null
									"
									:ort="
										brancheneintrag.zeige_adresse && brancheneintrag.adresse.ort
											? brancheneintrag.adresse.ort
											: null
									"
									:strasse="
										brancheneintrag.zeige_adresse &&
										brancheneintrag.adresse.strasse
											? brancheneintrag.adresse.strasse
											: null
									"
								/>
							</nk-col>
							<nk-col
								v-if="brancheneintrag.bild && options.showImages"
								cols="full"
								order="1"
								sm="4/12"
								order-sm="2"
							>
								<nk-link :link="brancheneintrag.detailURL" block tabindex="-1">
									<nk-image
										:src="brancheneintrag.bild"
										:alt="brancheneintrag.bildtext"
										:copyright="brancheneintrag.bildcopyright"
										ar="4:3"
										image-class="w-full"
									/>
								</nk-link>
							</nk-col>
						</nk-row>
					</article>
				</nk-list-item>
			</nk-list>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
/**
 * @prop {string} context.rubriken
 * @prop {boolean} options.showImages
 */
export default {
	name: 'NkTemplateBrancheneintraegeRubriken',

	mixins: [TemplatesDefault],
};
</script>
